import { render, staticRenderFns } from "./requests-item.vue?vue&type=template&id=0d748d08&scoped=true"
import script from "./requests-item.vue?vue&type=script&lang=js"
export * from "./requests-item.vue?vue&type=script&lang=js"
import style0 from "./requests-item.vue?vue&type=style&index=0&id=0d748d08&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d748d08",
  null
  
)

export default component.exports